import { Text } from '@cad-arc';
import { CommonSize } from './utils';

export function getDataItemText(fontSize?: CommonSize, content?: string | number | null) {
    return content !== undefined ? <Text fontSize={fontSize}>{content}</Text> : '';
}
